<!-- 留言咨询 -->
<template>
  <div>
    <app-breadcrumb/>
    <div class="page-container recharge-manage">
      <el-form size="small" :inline="true" :model="listQuery">
        <!-- 标题 -->
        <el-form-item :label="$t('icInformation.title') + ':'">
          <el-input v-model.trim="listQuery.title" style="width:140px;"/>
        </el-form-item>
        <el-button :loading="btnLoading" size="small" type="primary" icon="el-icon-search" @click="handleFilter">
          {{ $t('function.menu.search') }}
        </el-button>
        <el-button :loading="btnLoading" size="small" type="info" icon="el-icon-plus" @click="addBtn">
          {{ $t('amMessage.sendmsg') }}
        </el-button>
      </el-form>
      <el-table
          v-loading="tableLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
      >
        <el-table-column :label="$t('sysOperationLog.moduleName')" width="160" header-align="center" align="center">
          <template v-slot="{row}">
            <el-button v-show="!row.replyTime" circle size="mini" icon="el-icon-edit" :title="$t('button.edit')" @click="editTableBtn(row)"/>
            <el-button v-show="!row.replyTime" circle size="mini" icon="el-icon-delete" :title="$t('button.delete')"
                       @click="deleteTableBtn(row)"/>
          </template>
        </el-table-column>
        <!-- 内容 -->
        <el-table-column :label="$t('icInformation.content')" prop="localMoney" align="center">
          <template v-slot="{row}">
            <div style="width: 100%;">
              <div style="text-align: left">
                <p><span style="color: red">{{ $lt(initDict.infortype, row.inforType) }}</span>
                  {{ $t('icInformation.title') }}: <span style="color: #0000ff">{{ row.title }}</span></p>
              </div>
              <div style="text-align: left">
                <div @click="showDetail(row,'1')"
                     style="width: 45%;height: 50px;margin: 5px 2.5%;padding: 2px 1%;float: left;background-color: rgb(255, 238, 170);border: 1px solid #BED5F0">
                  <p>{{ $t('pd.createUserNo') }}:<span style="color: #0000ff">{{ row.createUser }}</span>
                    {{ row.createName }} {{ row.createTime }}</p>
                  <p style="width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                    {{ row.content }}
                  </p>
                </div>
                <div @click="showDetail(row,'2')"
                     style="width: 45%;height: 50px;margin: 5px 2.5%;padding: 2px 1%;float: right;background-color: #FFFFCC;border: 1px solid #BED5F0">
                  <p v-show="!row.replyTime">{{ $t('ammessage.noreplynum') }}</p>
                  <p v-show="row.replyTime">{{ $t('icInformation.replyUser') }}:<span style="color: #0000ff">{{ row.replyUser }}</span>
                    {{ row.replyName }} {{ row.replyTime }}</p>
                  <p v-show="row.replyTime" style="width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                    {{ row.replyContent }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList"/>
    </div>
    <el-dialog
        :title="$t('icInformation.content')"
        :visible.sync="centerDialogVisible"
        width="50%"
        center>
      <span>{{ pageCont }}</span>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="centerDialogVisible = false">{{ $t('button.confirm') }}</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"
import {informationDrop, informations} from "@/api/ic/icInformation";

export default {
  name: 'AdvisoryMessage',
  components: {Pagination},
  data() {
    return {
      pageCont: '',
      centerDialogVisible: false,
      btnLoading: false,
      tableLoading: false,
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10
      },
      initDict: {
        infortype: 'type.infortype.cn'
      }
    }
  },
  computed: {
    inforTypeList() {
      return this.$ll(this.initDict.infortype)
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.tableLoading = true
      this.btnLoading = true
      informations({...this.listQuery}).then(res => {
        this.list = res.data.records
        this.total = +res.data.total || 0
        this.btnLoading = false
        this.tableLoading = false
      }).catch(err => {
        console.warn(err)
        this.btnLoading = false
        this.tableLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    addBtn() {
      this.$router.push({name: 'EditAdvisoryMessage'})
    },
    showDetail(row, num) {
      num==='1' ? this.pageCont = row.content : this.pageCont = row.replyContent
      this.pageCont.length ? this.centerDialogVisible = true : ''
    },
    editTableBtn(row) {
      this.$router.push({name: 'EditAdvisoryMessage', params: {content: row}})
    },
    deleteTableBtn(row) {
      this.$confirm(this.$t('fi.sure.handle'), '提示', {
        confirmButtonText: this.$t('yesno.yes'),
        cancelButtonText: this.$t('yesno.no'),
        type: 'warning'
      }).then(() => {
        informationDrop({'id': row.uniNo}).then(() => {
          // 操作成功
          this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
          this.getList()
        }).catch(() => {
          // 操作失败
          this.$message.error(this.$t('bdSendRegister.operaterFail'))
          this.btnLoading = false
        })
      }).catch(() => {
        this.btnLoading = false
        this.$message.info(this.$t('pr.returned'))
      })
    }
  }
}
</script>

<style scoped>

</style>
